var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "#ffffff;",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.51349 9.69032L9.78552 0.418764C10.2325 -0.0282597 10.9577 -0.0282597 11.4047 0.418764L12.4863 1.5003C12.9328 1.94685 12.9333 2.6701 12.4882 3.1176L5.13973 10.4999L12.4877 17.8827C12.9333 18.3302 12.9323 19.0535 12.4858 19.5L11.4043 20.5816C10.9572 21.0286 10.2321 21.0286 9.78505 20.5816L0.51349 11.3095C0.0664669 10.8625 0.0664669 10.1373 0.51349 9.69032Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.351dbd96bce515e65a497abc5b0ac11b.svg";
export { ForwardRef as ReactComponent };